const initialState = { data: [], loading: true };

export const GetAllMaterialReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_all_material":
      return {
        data: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
